<template>
  <div class="row no-gutters body">
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../../assets/pageloader.svg" class="pageloader" alt="">
    </div>
    <div class="col-12 mb-4" v-if="!pageloader">
      <div class="row no-gutters">
        <div class="col-lg-3 middle-background"></div>
        <div class="col-md-12 col-lg-6 middle-background main-card">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters mt-5">
            <div class="col-lg-12">
              <div class="row no-gutters">
                <br />
              </div>
              <div class="col-lg-12">
                <div class=" card card1 mt-lg-2 jobSec" v-if="userNotFound">
                  <div class="d-flex flex-column p-5 mx-auto">
                  <img src="../../assets/userNotFound.png" class="img-fluid col-10 col-md-8 no-video mt-5 mb-5 mx-auto" alt="novideo">
                  <!-- <span class="text-center proximanova-bold black60 mb-5 fontsize24"> User Not Found </span> -->
                  </div>
                </div>
                <div class="row no-gutters" @click="previous" v-if="!userNotFound">                  
                    <img src="../../assets/Back.svg" class="img-fluid mr-1 ml-md-3" alt="backbtn" />
                    <div class="d-flex flex-column">
                      <span class="ml-2 fontsize16 my-auto proximanova-bold black prof-details pointer hover">{{companyDetails.companyName}}</span>  
                      <div v-if="selecetdcompanyAliasName" class="proximanova ml-1 fontsize12 black pointer">@{{selecetdcompanyAliasName}}</div>
                    </div>                  
                </div>
              </div>
              <div class="card card1 ml-3 mr-3 mt-lg-2" v-if="!userNotFound">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-2 col-md-2 col-3">
                      <div class="profile-pic"  data-toggle="modal" data-target="#exampleModalprofile">
                        <div class="profile-border">
                          <img v-if="companyDetails.companyLogoLink" :src="companyDetails.companyLogoLink" alt="companylogo" oncontextmenu="return false" class="img-fluid rounded-circle profileimgad loadingBgImg" id="profImage">
                          <img v-else class="img-fluid rounded-circle hover" id="profImage" src="../../assets/Profile_placehlder.svg" alt="defaultlogo" />
                        </div>
                       
                      </div>
                    </div>
                    <div class="col-lg-10 col-md-10 col-9 nameblock">
                      <!-- <div>
                        <span class="">
                          <img src="../../assets/horizontal_menu_icon.svg" width="20px" id="welcomemore" class="img-fluid float-right mr-2 mt-1 menuicon more_optionhoriz" alt="moremenuicon">
                        </span>
                      </div> -->
                      <div class="float-right mt-1 proximanova-semibold fontsize16 black60  hover d-flex">
                        <span class="mr-3 pointer"  id="follow">
                          <button @click="followCompany" :disabled="disablefollowBtn" v-if="followingTest === 'Follow'" class="bordernone backgroundnone mouseoverbtn1 fontsize16 black60 proximanova-semibold pointer">{{followingTest}}</button>
                          <button @click="unfollowCompany" :disabled="disablefollowBtn" v-if="followingTest === 'UnFollow'" class="bordernone backgroundnone mouseoverbtn1 fontsize16 black60 proximanova-semibold pointer">{{followingTest}}</button>
                        </span>
                        <div class="ml-1">
                          <span class="" >
                            <img src="../../assets/horizontal_menu_icon.svg" v-popover:selecteduser width="20px" id="selectedusermore" class="pointer img-fluid float-right mr-2 mt-1 menuicon moreactionsmenu" alt="moremenuicon">
                          </span>
                          <popover name="selecteduser" class="welcomemenu">
                            <div class="p-2">
                                <div class="d-flex p-1 justify-content-between">
                                  <span class="fontsize12 proximanova-bold black">More Actions</span>
                                  <div class="closebtnmouseover">
                                    <img src="../../assets/Close1.svg" class="img-fluid pr-1 closebtn" alt="closebtn" @click="closeMoreActions">
                                  </div>
                                </div>
                                <div class="d-flex p-1 action" id="onclickshare" @click="shareprofileLink">
                                    <img src="../../assets/Share.svg" alt="share" class="img-fluid pl-1 pr-1 ">
                                    <span class="pt-2 pl-2 d-flex flex-column">
                                      <div class="proximanova fontsize14 black80">Share</div>
                                      <div class="fontsm black60 proximanova">Profile can share with any one</div>
                                    </span>
                                </div>
                                <div class="d-flex p-1 action" id="onclickshare" @click="copyprofileLink">
                                    <img src="../../assets/hyperlink1.png" alt="share" class="copylink img-fluid my-auto pl-1 pr-1 ">
                                    <span class="pt-2 pl-2 d-flex flex-column">
                                      <div class="proximanova fontsize14 black80">Copy Profile Link</div>
                                      <div class="fontsm black60 proximanova">Profile can share with any one</div>
                                    </span>
                                </div>
                                <!-- <div class="d-flex p-1 action" id="onclickshare">
                                    <img src="../../assets/Hide.svg" class="img-fluid pl-1 pr-1 " alt="hideicon">
                                    <span class="pt-2 pl-2 d-flex flex-column">
                                      <div class="fontsize14 black80 proximanova">Block Profile</div>
                                      <div class="fontsize12 black60 proximanova">No longer connected</div> 
                                    </span>
                                </div>
                                <div class="d-flex p-1 action">
                                    <img src="../../assets/Report.svg" class="img-fluid pl-1 pr-1" alt="reporticon">
                                    <span class="pt-2 pl-2 d-flex flex-column">
                                      <div class="fontsize14 black80 proximanova">Report Profile</div>
                                      <div class="fontsize12 black60 proximanova">This profile is not relevent and offencive</div>  
                                    </span>
                                </div> -->
                            </div>
                          </popover>
                        </div>
                      </div>
                      <div class="fontsize22 proximanova-bold ml-1 welcomename">{{companyDetails.companyName}}</div>
                      <div v-if="selecetdcompanyAliasName" class="proximanova ml-1 fontsize14 black">@{{selecetdcompanyAliasName}}</div>
                      <div class="d-flex pl-1 text-capitalize sidemenuItem">
                        <div v-if="companyDetails.industry" class="fontsize16 proximanova black60">{{companyDetails.industry}}</div>
                        <div class="verticaline ml-2 mr-2"> | </div>
                        <div v-if="companyDetails.countryName" class="fontsize16 proximanova black60">{{companyDetails.countryName}}</div>
                      </div>
                      <div class="d-flex flex-nowrap ml-1 pr-1">
                        <div class="fontsize14 proximanova black60">
                          {{companyDetails.totalDescription}}
                          <span @click="readmoreCompanyDescription()" v-if="companyDetails.totalDescription && companyDetails.totalDescription.length>124"><span v-if="!readmoreclicked" class="fontsize14 blue pointer">...readmore</span></span><span class="fontsize14 blue pointer" v-if="readmoreclicked" @click="readlessCompanyDescription()">...readless</span>
                        </div>
                      </div>
                      <div class="d-flex flex-nowrap mt-3 ml-1 pr-1">
                        <a class="fontsize14 blue proximanova my-auto" v-if="companyDetails.twitterURL" :href="companyDetails.twitterURL" target="_blank">
                          <img src="../../assets/twitter.svg" class="img-fluid" width="25px" alt="twitter">
                        </a>
                        <a class="fontsize14 blue proximanova my-auto" v-if="companyDetails.linkedInURL" target="_blank" :href="companyDetails.linkedInURL">
                          <img src="../../assets/linkedin.svg" class="img-fluid ml-3" width="23px" alt="linkedin">
                        </a>
                        <a class="fontsize14 blue proximanova my-auto" v-if="companyDetails.youtubeURL" target="_blank" :href="companyDetails.youtubeURL">
                          <img src="../../assets/youtube.svg" class="img-fluid ml-3" width="27px" alt="youtube">
                        </a>
                      </div>
                      <div class="mt-3 d-flex">
                          <div class="d-flex ml-1 flex-column">
                            <label class="mr-lg-5 mr-3 fontsize14 black60 proximanova stylebold countlabel">Posts</label>
                            <label class="fontsize20 black60 proximanova countValue" v-if="postedVideosCount != null">{{postedVideosCount}}</label>
                          </div>
                          <div class="d-flex flex-column">
                            <label class="mr-lg-5 mr-3 fontsize14 black60 proximanova stylebold countlabel">Followers</label>
                            <label class="fontsize20 black60 proximanova countValue" v-if="followersCount != null" @click="routetosuggestedpage('followers')">{{followersCount}}</label>
                          </div>
                          <div class="d-flex flex-column">
                            <label class="fontsize14 black60 proximanova stylebold countlabel">Following</label>
                            <label class="fontsize20 black60 proximanova countValue" v-if="followingCount != null" @click="routetosuggestedpage('following')">{{followingCount}}</label>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <member-tab v-if="showMemberTab && !userNotFound"></member-tab>
            </div>
          </div>
        </div>
        <div class="col-lg-3 middle-background"></div>
      </div>
    </div>
    <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal> 
  </div>
</template>
<script>
import Vue from "vue";
import Popover from "vue-js-popover";
import memberTab from './MemberView.vue'
import httpuserprofile from "@/js/http-userprofile.js";
import httpbusiness from "@/js/http-business.js"
import router from '../../router.js'
import APIerrorModal from '../../components/APIerrorpopup.vue'
import sessionUtils from '@/js/session-util.js'
import { bus } from "@/main.js";
Vue.use(Popover);
export default{
  components:{
    memberTab,
    APIerrorModal
  },
  data(){
    return{
      userNotFound : false,
      pageloader: true,
      currentUserProfileId : null,
      businessAccountId : null,
      companyProfileId : null,
      selecetdcompanyAliasName : null,
      activeMember: "admin",
      selectedProfileFile: '',
      imgSelected: false,
      uploadphoto:"true",
      showMemberTab : true,
      //topcard section
      profilePictureObj : {},
      showProfilePictureModal : false,
      followingTest : 'Follow',
      disablefollowBtn : false,
      companyDetails : {},
      readmoreclicked : false,
      postedVideosCount : 0,
      followersCount : 0,
      followingCount : 0,
      displayAPIerrorModal : false,
    }
  },
  watch: {
    '$route.params.id': function (id) {     
      this.businessAccountId = id;
      this.pageloader = true;
      this.getCompanyData(id);   
    },    
},
  methods:{
    closeAPIerrorModal(){
      this.displayAPIerrorModal = false;
    },
    shareprofileLink : function() {
      var vm = this;
      if (!navigator.share) return;

      navigator.share({
            url: "https://worknotion.com/wncompany/"+this.selecetdcompanyAliasName,
            title: "Worknotion | Sign Up and Connect with Experienced Individuals Around the Globe",
            text: "Worknotion helps you to interact with professionals and Businesses around the world. Upload your business profile today with short videos and gain more visibility!"
        })
        .then(() => { console.log("Shared YEEEE!!!!!"); })
        .catch((error) => { vm.$toast.info("No longer support this functionality in this device/browser") });
    },
    copyprofileLink : function() {
      var vm = this;
      var link = "https://worknotion.com/wncompany/"+this.selecetdcompanyAliasName
      // var link = "http://localhost:8080/wncompany/"+this.selecetdcompanyAliasName
      navigator.clipboard.writeText(link);
      vm.$toast.success("Copied to clipboard")
    },
    //navigate user to suggested people after click on followres/following count
    routetosuggestedpage:function(element){
      this.$router.push({name: 'selectedCompanyPeople', params: { id: this.selecetdcompanyAliasName , peopleType : element}});
    },
    closeMoreActions : function(){
      document.getElementById('selectedusermore').click()
    },
    previous(){
      this.$router.go(-1);
    },
    // fetching copany profile information
    getCompanyData(companyAliasName) {
      // httpuserprofile.get('/userprofile/getcompanyProfileData?businessAccountId='+businessAccountId)
      httpbusiness.get('/business/getcompanyProfileDataByAliasName?aliasName='+companyAliasName)
      .then((response) => {
        this.pageloader = false;
        if(response.data && response.data.errorCode && response.data.errorCode == 1021){
          this.userNotFound = true;
        }else{
          this.userNotFound = false;
        }
        let companyDetails = response.data;
        this.businessAccountId = response.data.businessAccountId;
        this.$session.set("business_account_id", this.businessAccountId);
        this.$session.set("company_profile_id", response.data.companyProfileId);
        this.companyProfileId = response.data.companyProfileId;
        let companyDescription = response.data.description;
          if(companyDescription) {
            companyDetails.companyDescription1 = companyDescription.substr(0, 125)
            companyDetails.totalDescription = companyDetails.companyDescription1
            companyDetails.companyDescription1 = companyDescription.substr(0, 125)
            companyDetails.companyDescription2 = companyDescription.substr(125)
          }
        this.companyDetails = companyDetails;
        if(!this.userNotFound){
        this.fetchFollowFlag()
        this.fetchCompanyFollowCounts()
        }
        console.log(this.companyDetails)
      }).catch((e) => {
        console.log(e)
        this.pageloader = false;
      })
    },
    // fetching the follow relation between loggedin user and the company
    fetchFollowFlag(){
      httpuserprofile.get("/userprofile/getUsertoCompanyFollowFlag?profileId="+this.currentUserProfileId+'&companyProfileId='+this.companyProfileId)
      .then((response) => {
        console.log("company follow flag : ", response)
        let followflag = response.data[0].followingFlag;
        if(followflag == 'Y'){
          this.followingTest =  'UnFollow'; 
        }else if(followflag == 'N'){
          this.followingTest =  'Follow'; 
        }
      })
    },
    //fetching the counts of posted videos, followers and following users count for the selected company
    fetchCompanyFollowCounts(){
      httpuserprofile.get("/userprofile/getCompanyFollowAndFollowingCount?companyProfileId="+this.companyProfileId)
      .then((response) => {
        console.log("counts of the company : ", response);
        this.postedVideosCount = response.data.postedVideoCount;
        this.followersCount = response.data.followerCount;
        this.followingCount = response.data.followingCount;
      })
    },
    //follow company
    followCompany() {
      this.disablefollowBtn = true;
      httpuserprofile.post("/userprofile/saveUserToCompanyFollowing?UserProfileId="+this.currentUserProfileId+"&CompanyProfileId="+this.companyProfileId)
      .then(response => {
        console.log("user to company follow : ", response)
        // after successfully saved get followers list of the company to update the data  
        this.followingTest =  'UnFollow'; 
        this.followersCount = this.followersCount + 1;
        this.disablefollowBtn = false;
      }).catch((e) => {
        console.log(e)
        this.disablefollowBtn = false;
        this.displayAPIerrorModal = true;
      }); 
    },
    //unfollow company
    unfollowCompany() {
      this.disablefollowBtn = true;
      httpuserprofile.delete("/userprofile/UserToCompanyunfollow?UserProfileId="+this.currentUserProfileId+"&CompanyProfileId="+this.companyProfileId)
      .then(response => {
        console.log("user to company unfollow : ", response)
        // after successfully saved get followers list of the company to update the data  
        this.followingTest =  'Follow'; 
        this.followersCount = this.followersCount - 1;
        this.disablefollowBtn = false;
      }).catch((e) => {
        console.log(e)
        this.disablefollowBtn = false;
        this.displayAPIerrorModal = true;
      });
    },
    // readmore/readless company description functionality
    readmoreCompanyDescription : function(){
      this.companyDetails.totalDescription = this.companyDetails.totalDescription.concat(this.companyDetails.companyDescription2)
      this.readmoreclicked = true
    },
    readlessCompanyDescription : function() {
      this.readmoreclicked = false;
      this.companyDetails.totalDescription = this.companyDetails.totalDescription.substr(0, 125)
    },
  },
  mounted() {
    // this.businessAccountId = this.$route.params.id;
    this.selecetdcompanyAliasName = this.$route.params.id;
    this.currentUserProfileId = sessionUtils.getUserProfileId()
    this.getCompanyData(this.selecetdcompanyAliasName)
  }
}
</script>
<style scoped>
.nav-link {
  padding: 0px 0px 0px 0px;
}
.loadingBgImg{
  background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.nav-tabs {
  border-bottom: none !important;
}
.card-header {
  padding: 5px 10px 5px 10px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
  background-color: #f0f2f5;
}
.countValue:hover{
  color: #0078ff !important;
  cursor: pointer;
  text-decoration: underline;
}
.jobSec {
  /* background-color: #e8e9eb; */
  background-color: rgba(161, 166, 179, 0.085) !important;
  border: none !important;
}
.card-header {
  border-radius: 8px !important;
}
.moreactionsmenu{
  border: 1px solid white;
  border-radius: 50%;
  padding: 2px;
}
.moreactionsmenu:hover{
  border: 1px solid gray;
  border-radius: 50%;
}
.profile-pic {
	position: relative;
	display: inline-block;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
.pageloader{
  width: 5%;
  margin-left: 45%;
  margin-top: 20%;
}
.edit {
  cursor: pointer;
  border: 1px solid rgba(31, 31, 31, .1);
  border-radius: 50%;
	position: absolute;
	right: 0;
	top: 0;
  margin-top:70%
}
.copylink{
  height: 20px !important;
}
.closebtn {
  cursor: pointer;
  /* width: 20px;
  height: 20px; */
  margin-top: -5px;
  border-radius: 50%;
  padding-left: 3px;
  padding-top: 3px;
}
.closebtnmouseover{
border: 1px solid white;
}
.closebtnmouseover:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 50%;
    padding: 0 1px;
  /* padding-left: 6px;
  padding-right: 3px; */
  border: 1px solid rgba(161, 166, 179,.5);
}
.action {
  cursor: pointer;
}
.action:hover {
  background-color:rgba(221, 223, 229,0.4);
  border-radius: 5px;
}
.mouseoveraction:hover{
	background-color: rgba(161, 166, 179,.2);
  border-radius: 8px;
}
.prof-details{
  margin-top: 6px;
  cursor: pointer;
}
.border-tab {
  border-bottom-style: solid;
  border-bottom-color: #0078ff;
}
.list-text-color {
  color: #0078FF ;
  font-family: "Proxima Nova";
  font-weight: bold;
  letter-spacing: 0;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
nav ul li a {
  padding: 0.5rem 0.9rem;
}
.nameblock {
  padding-left: 0 !important;
}
.welcomemenu.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.welcomemenu.dropdown-position-bottom {
  left: unset !important;
  top: 20px !important;
  width: 290px !important;
  padding: 10px 10px 10px 10px !important;
  transform: translate3d(-80%, 10px, 10px) !important;
}
@media only screen and (max-width: 600px) {
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
  .fontsize22{
    font-size: 18px !important;
  }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
</style>
